import React, { useState, useEffect } from "react";
import { Row, Col, Card, Divider, Menu, Input } from "antd";
import "./index.css";
import Tabs from "../../components/tab/index";
import {
  AiOutlineSearch,
  BsCalendarMinus,
  AiOutlinePlus,
} from "react-icons/all";
import TableWrapper from "../Grid";
import moment from "moment";
import { useHistory } from "react-router-dom";
import RadioWrapper from "../RadioWrapper";
import { GrClose } from "react-icons/gr";
export default function PlantOrder({
  inputText,
  manufacturePlants,
  logisticPartners,
  onChangeTab,
  metaData,
  currentPage,
  previousPage,
  onChangeText,
  isLoader,
  isLogisticLoader,
  onChangeFilter,
  onChangePeriod,
  columns,
  isShowManufacturingPlants,
  isShowLogisticPartners,
  isShowAsphaltPlants,
  isShowLogisticDetail,
  onCurrentPage,
  onPreviousPage,
  isShowProducts,
  products,
  onChangeCatalog,
  Orders,
  logisticOrders,
  isShowPlusSign,
  searchVal,
  onClearSearch,
  isAddIcon,
  activeKey,
  getTabProductKey,
}) {
  const [isClose, setIsclose] = useState(false);
  const [radioValue, setRadioValue] = useState("");
  const history = useHistory();
  const [isVisible, setVisible] = useState(false);
  const [periodValue, setPeriodValue] = useState("");
  const [value1, setValue1] = useState("");
  const [value2, setValue2] = useState("");

  let days = [];
  let daysRequired = 7;
  let nextDays = [];

  for (let i = daysRequired; i >= 1; i--) {
    days.push(
      moment()
        .add(i + 1, "days")
        .format("dddd, D")
    );
  }
  for (let i = daysRequired; i >= 1; i--) {
    nextDays.push(
      moment()
        .add(i + 1, "days")
        .format("YYYY-MM-DD")
    );
  }
  console.log("NEXT_DAYS", columns);

  useEffect(() => {
    onChangeFilter(nextDays[value2], nextDays[value1]);
  }, [value1, value2]);

  const saveDates = days.reverse().map((item) => {
    const ab = item.split(",");
    return { key: ab[0].charAt(0), value: ab[1] };
  });

  console.log("value==>", nextDays[value1], nextDays[value2]);
  const menu = (
    <Menu>
      <Row>
        <Col span={4}>
          <RadioWrapper
            name="abc"
            value={"last7days"}
            checked={radioValue === "last7days"}
            onChange={() => {
              onChangeFilter(
                moment().format("YYYY-MM-DD"),
                moment().subtract(1, "weeks").format("YYYY-MM-DD")
              );
              setRadioValue("last7days");
            }}
          />
        </Col>
        <Col xl={12}>
          <p> Last 7 Days</p>
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <RadioWrapper
            name="abc"
            value={"lastMonth"}
            checked={radioValue === "lastMonth"}
            onChange={() => {
              onChangeFilter(
                moment().format("YYYY-MM-DD"),
                moment().subtract(1, "month").format("YYYY-MM-DD")
              );

              setRadioValue("lastMonth");
            }}
          />
        </Col>
        <Col xl={12}>
          <p> Last Month</p>
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <RadioWrapper
            name="abc"
            value={"date"}
            checked={radioValue === "date"}
            style={{ cursor: "pointer" }}
            onChange={(e) => {
              setRadioValue("date");
            }}
          />
        </Col>
        <Col xl={12}>
          <p> Date</p>
        </Col>
        <Col xl={24} style={{ height: "4rem", background: "#F1F1F1" }}>
          <Row justify="space-between" style={{ margin: "auto" }}>
            {saveDates.map((v, index) => {
              const sp = days[index].split(",");
              return (
                <>
                  <Col span={3}>
                    <p
                      style={{
                        textAlign: "center",
                        color: sp[0] === "Sunday" ? "red" : "grey",
                        fontSize: "13px",
                      }}
                    >
                      {v.key}
                    </p>
                  </Col>
                </>
              );
            })}
          </Row>
          <Row justify="space-between" style={{ margin: "auto" }}>
            {saveDates.map((v, index) => {
              return (
                <>
                  <Col span={3}>
                    <p
                      className="pointer-cursor"
                      style={{
                        backgroundColor:
                          saveDates[value1]?.value === v.value
                            ? "#19ABAA"
                            : saveDates[value2]?.value === v.value
                              ? "#AB4119"
                              : "",
                        height: "22px",
                        width: "22px",
                        borderRadius: "50%",
                        display: "inline-block",
                        textAlign: "center",
                        color:
                          saveDates[value1]?.value === v.value
                            ? "white"
                            : saveDates[value2]?.value === v.value
                              ? "white"
                              : "black",
                      }}
                      onClick={() => {
                        if (value1 === index) {
                          setValue1("");
                          return;
                        }
                        if (value2 === index) {
                          setValue2("");
                          return;
                        }
                        if (value1 === "") {
                          setValue1(index);
                          return;
                        }
                        if (value2 === "") {
                          setValue2(index);
                          return;
                        }
                      }}
                    >
                      {v.value}
                    </p>
                  </Col>
                </>
              );
            })}
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xl={6}>
          <p>Time</p>
        </Col>
        <Col xl={8}>
          <RadioWrapper
            value={"am"}
            checked={periodValue === "am"}
            onChange={() => {
              onChangePeriod("am");
              setPeriodValue("am");
            }}
          />
          <span>AM</span>
        </Col>

        <Col xl={6}>
          <RadioWrapper
            value={"pm"}
            checked={periodValue === "pm"}
            onChange={() => {
              onChangePeriod("pm");
              setPeriodValue("pm");
            }}
          />
          <span>PM</span>
        </Col>
      </Row>
    </Menu>

  );

  return (
    <>
      <Row justify="start">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          style={{ marginTop: "1.5em" }}
        >
          <Row justify="start">
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="custom">
              <Card style={{ padding: "1rem" }}>
                <Row justify="space-between">
                  <Col xl={12} xs={24} sm={24} md={12} lg={12}>
                    <Row>
                      <Col xl={24} xs={24} sm={18} md={24} lg={24}>
                        <h5 className="text-left">{inputText}</h5>
                      </Col>
                    </Row>
                  </Col>
                  <Col style={{ display: "flex" }}>
                    <AiOutlineSearch
                      size="22"
                      onClick={() => {
                        setIsclose(!isClose);
                      }}
                      className="pointer-cursor"
                    />
                    <Input
                      placeholder="Search..."
                      style={{
                        width: isClose ? "180px" : "0px",
                        padding: 0,
                        background: "transparent",
                        border: "none",
                        borderBottom: "1px solid #000",
                      }}
                      value={searchVal}
                      onChange={onChangeText}
                    />
                    {isClose && (
                      <GrClose
                        size="15"
                        onClick={() => {
                          setIsclose(!isClose);
                          if (onClearSearch) {
                            onClearSearch();
                          }
                        }}
                        style={{ marginRight: "20px" }}
                        className="pointer-cursor"
                      />
                    )}
                    {!isShowPlusSign && (
                      <span className="pointer-cursor">
                        <AiOutlinePlus
                          size="22"
                          onClick={() => history.push(onChangeCatalog)}
                        />
                      </span>
                    )}
                  </Col>

                  <Divider
                    className="ant-divider-horizontal"
                    orientation="right"
                  ></Divider>
                </Row>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    {isShowManufacturingPlants && (
                      <Tabs
                        onChangeTab={onChangeTab}
                        plantData={[
                          {
                            key: "ALL",
                            component: () => (
                              <TableWrapper
                                tableData={manufacturePlants}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "PENDING",
                            component: () => (
                              <TableWrapper
                                tableData={manufacturePlants}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "ACTIVE",
                            component: () => (
                              <TableWrapper
                                tableData={manufacturePlants}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "REJECTED",
                            component: () => (
                              <TableWrapper
                                tableData={manufacturePlants}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "INACTIVE",
                            component: () => (
                              <TableWrapper
                                tableData={manufacturePlants}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "UNSUBSCRIBED",
                            component: () => (
                              <TableWrapper
                                tableData={manufacturePlants}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                        ]}
                      />
                    )}
                    {isShowProducts && (
                      <Tabs
                        onChangeTab={onChangeTab}
                        activeKey={activeKey}


                        plantData={[
                          {
                            key: "PRODUCTS",
                            component: () => (
                              <TableWrapper
                                tableData={products}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "Product Taxable",
                            component: () => (
                              <TableWrapper
                                tableData={products}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "ADDITIVES",
                            component: () => (
                              <TableWrapper
                                tableData={products}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "CATEGORIES",
                            component: () => (
                              <TableWrapper
                                tableData={products}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                              // fromOrder={true}
                              />
                            ),
                          },
                        ]}
                      />
                    )}
                    {isShowLogisticPartners && (
                      <Tabs
                        onChangeTab={onChangeTab}
                        plantData={[
                          {
                            key: "ALL",
                            component: () => (
                              <TableWrapper
                                tableData={logisticPartners}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLogisticLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "PENDING",
                            component: () => (
                              <TableWrapper
                                tableData={logisticPartners}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLogisticLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "ACTIVE",
                            component: () => (
                              <TableWrapper
                                tableData={logisticPartners}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLogisticLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "REJECTED",
                            component: () => (
                              <TableWrapper
                                tableData={logisticPartners}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLogisticLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "INACTIVE",
                            component: () => (
                              <TableWrapper
                                tableData={logisticPartners}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLogisticLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "UNSUBSCRIBED",
                            component: () => (
                              <TableWrapper
                                tableData={logisticPartners}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLogisticLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                        ]}
                      />
                    )}
                    {isShowAsphaltPlants && (
                      <Tabs
                        onChangeTab={onChangeTab}
                        plantData={[
                          {
                            key: "PENDING",
                            component: () => (
                              <TableWrapper
                                tableData={Orders}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "APPROVED",
                            component: () => (
                              <TableWrapper
                                tableData={Orders}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "DISPATCHED",
                            component: () => (
                              <TableWrapper
                                tableData={Orders}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "REJECTED",
                            component: () => (
                              <TableWrapper
                                tableData={Orders}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "COMPLETED",
                            component: () => (
                              <TableWrapper
                                tableData={Orders}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                        ]}
                      />
                    )}
                    {isShowLogisticDetail && (
                      <Tabs
                        onChangeTab={onChangeTab}
                        plantData={[
                          {
                            key: "PENDING",
                            component: () => (
                              <TableWrapper
                                tableData={logisticOrders}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "DISPATCHED",
                            component: () => (
                              <TableWrapper
                                tableData={logisticOrders}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "PICKED",
                            component: () => (
                              <TableWrapper
                                tableData={logisticOrders}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "DROPPED",
                            component: () => (
                              <TableWrapper
                                tableData={logisticOrders}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                          {
                            key: "COMPLETED",
                            component: () => (
                              <TableWrapper
                                tableData={logisticOrders}
                                tableColumns={columns}
                                metaData={metaData}
                                currentPage={currentPage}
                                previousPage={previousPage}
                                isLoader={isLoader}
                                fromOrder={true}
                              />
                            ),
                          },
                        ]}
                      />
                    )}
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
